import { Link } from 'react-router-dom';
import './financial.scss';

export default function FinancialKeyMotivator() {
  return (
    <>
      <h5>Key Motivator for Financial Companies</h5>
      <p>Being able to track campaigns—from printing all the way to delivery—would be  financial companies’ top motivator for increasing direct mail use going forward.</p>

      <ul>
        <li>The <a href="/../track-your-direct-mail-with-informed-visibility/">Informed Visibility<sup className='key-motivator-symbol'>&reg;</sup> feature</a> provides businesses with near-real-time updates on the progress of their mailpieces.</li>
      </ul>
    </>
  );
}
